import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BatteryQuoterService } from './battery-quoter.service';
import { AnalyticsEvent, AnalyticsScreenViewEvent, AnalyticsService } from '../../services/analytics';
import { environment } from '../../../environments/environment';
import { FormComponent } from './components/form/form.component';
import { ResultsComponent } from './components/results/results.component';
import { NoResultsComponent } from './components/no-results/no-results.component';
import { WindowRefService } from '../share/services/window-ref.service';

@Component({
  selector: 'ava-battery-quoter',
  template: `
    <div style="padding: 20px; background-color: white">
      @if (bs.componentState === bs.ComponentState.FORM) {
        <ava-form />
      }

      @if (bs.componentState === bs.ComponentState.RESULTS) {
        <ava-results />
      }

      @if (bs.componentState === bs.ComponentState.NO_RESULTS) {
        <ava-no-results />
      }
    </div>
  `,
  standalone: true,
  imports: [ResultsComponent, NoResultsComponent, FormComponent, CommonModule],
})
export class BatteryQuoterComponent implements OnInit {
  readonly environment = environment;
  windowRef = inject(WindowRefService);
  bs = inject(BatteryQuoterService);
  analyticsService = inject(AnalyticsService);

  ngOnInit(): void {
    this.bs.resetMake();
    this.bs.getMakes();
    this.bs.setComponentState('init', this.bs.ComponentState.FORM);

    const eventCustomElement: AnalyticsEvent = {
      eventCategory: 'Custom Element',
      eventAction: 'Supported',
      eventLabel:
        '<ava-battery-quoter>' +
        this.windowRef.nativeWindow.location.origin.toLowerCase() +
        this.windowRef.nativeWindow.location.pathname.toLowerCase(),
      eventValue: 1,
    };
    this.analyticsService.sendEvent(eventCustomElement);

    const analyticsScreenViewEvent: AnalyticsScreenViewEvent = {
      eventName: 'screen_view',
      eventParams: {
        firebase_screen: 'Battery-Quote',
        firebase_screen_class: 'Battery-Quote',
        action: this.windowRef.nativeWindow.location.pathname.toLowerCase(),
      },
    };
    this.analyticsService.sendFirebaseScreenViewEvent(analyticsScreenViewEvent);
  }
}
